import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { AZURE_KNOWN_AUTHORITIES } from '../environment';

type TeamsCapabilities = {
  microsoftTemplatesAvailable: boolean;
};

export const keys = {
  teamsCapabilities: 'teamsCapabilities',
} as const;

/**
 * Detects sovereign cloud from AZURE_KNOWN_AUTHORITIES as a frontend-only
 * fallback. Returns `true` when the authority hostname ends with `.us` (e.g.
 * `login.microsoftonline.us` for Azure Government / DoD).
 */
function isFrontendSovereignCloud(): boolean {
  try {
    if (AZURE_KNOWN_AUTHORITIES && AZURE_KNOWN_AUTHORITIES.includes('.us')) {
      return true;
    }
  } catch {
    // Ignore parse errors — fall through to non-sovereign
  }
  return false;
}

export const useFetchTeamsCapabilities = () => {
  return useQuery<TeamsCapabilities>({
    queryKey: [keys.teamsCapabilities],
    queryFn: async () => {
      try {
        const { data } = await axios.get<TeamsCapabilities>(
          config.apiGateway.teamsCapabilities
        );
        return data;
      } catch {
        // Fallback: if the backend endpoint is not yet deployed (404), use frontend detection
        return {
          microsoftTemplatesAvailable: !isFrontendSovereignCloud(),
        };
      }
    },
    staleTime: Infinity,
  });
};
